import React from 'react';
import LaunchpadHome from '../../BasicComponents/LaunchpadHome';

const TenantLaunchpadHome = () => {
  return <LaunchpadHome mode="tenant" />;
};

export default TenantLaunchpadHome;
